<template>
	<v-card>
		<v-card-title style="display: block;">
			<div class="d-flex">
				<span class="headline">انتخاب نماینده</span>
				<v-spacer />
				<v-btn @click="$emit('close')" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>
		</v-card-title>
		<v-card-text>
			<v-container>
				<div>
					<div>
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</div>
					<div class="">
						<v-checkbox class="small" color="secondary" @change="checkboxAllChanged" label="انتخاب همه" />
					</div>
					<v-data-table dense :headers="headers" :loading="loading" :items="agents" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
						<template v-slot:item.ch="{ item }">
							<v-checkbox color="secondary" v-model="item.ch" @change="(val) => checkboxChanged(val, item)" />
						</template>
						<template v-slot:item.isActive="{ item }">
							<v-icon v-if="item.isActive" color="success" title="غیرفعال">
								mdi-check-circle
							</v-icon>
							<v-icon v-else color="error" title="فعال">
								mdi-close-circle
							</v-icon>
						</template>
					</v-data-table>
				</div>
			</v-container>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-spacer />
			<v-btn color="blue" dark @click="emitSelectedItems">
				تایید آیتم های انتخاب شده
			</v-btn>
			<v-spacer />
		</v-card-actions>
		<confirm-dlg ref="confirm" />
	</v-card>

</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'AgentsSelector',
		props: {
			selectedIds: { type: Array }
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				emptyId: emptyId,
				search: '',
				selectedItems: [],
				errorMessages: '',
				agents: [],
				loading: false,
				headers: [
					{
						text: '',
						align: 'start',
						sortable: false,
						value: 'ch',
						width: 20
					},
					{
						text: 'نام نماینده',
						align: 'start',
						sortable: true,
						value: 'firstName',
						width: 200
					}, {
						text: 'نام تجاری',
						align: 'start',
						sortable: true,
						value: 'businessName',
						width: 175
					}, {
						text: 'شماره تماس',
						align: 'start',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'اکانت فعال',
						align: 'center',
						sortable: true,
						value: 'isActive',
					}
				],
			}
		},
		computed: {
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/agent/ListLight', null)
					.then(
						response => {
							this.agents = response.map(x => {
								x.ch = this.selectedIds.includes(x.id)
								return x
							})
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			checkboxChanged(state, item) {
				let index = this.selectedItems.findIndex(x => x.id === item.id)
				if (!state && index > -1)
					this.selectedItems.splice(index, 1)
				if (state && index === -1) {
					this.selectedItems.push(item)
				}
			},
			emitSelectedItems() {
				if (!this.selectedItems.length) {
					toast.error('حداقل یک آیتم باید انتخاب شود.')
					return
				}
				this.$emit('select', this.selectedItems.map(x => x.id))
				this.$emit('close')
			},
			checkboxAllChanged(state) {
				this.agents.forEach(x => { x.ch = state })
				if (!state) {
					this.selectedItems = []
				} else {
					this.selectedItems = [...this.agents]
				}
			}
		},
	}
</script>
<style></style>
